import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3001/api/v1";

export default function ReturnPage() {
  const [status, setStatus] = useState<"checking" | "paid">("checking");
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const sessionId = new URLSearchParams(
      window.location.search
    ).get("session_id");

    if (!sessionId) return;

    const interval = setInterval(async () => {
      const res = await fetch(
        `${API_BASE_URL}/payment/session?session_id=${sessionId}`
      );
      const data = await res.json();

      // ✅ เช็คจาก backend + webhook
      if (data.paymentStatus === "paid") {
        setStatus("paid");
        setEmail(data.customerEmail);
        clearInterval(interval);
      }
    }, 1500);

    return () => clearInterval(interval);
  }, []);

  if (status === "checking") {
    return <p>⏳ Checking payment status...</p>;
  }

  return (
    <div>
      <h2>✅ Payment Successful</h2>
      <p>Receipt sent to {email}</p>

      <button onClick={() => navigate("/orders")}>
        Go to Orders
      </button>
    </div>
  );
}
